(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["nlt-category-panel"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', function(event) {
  const button = event.target.closest('.nlt-category-close');
  if (!button) return;
  const details = button.closest('details');
  if (!details) return;
  const menu = details.closest('header-menu');
  if (menu && typeof menu.close === 'function') menu.close();
  details.removeAttribute('open');
  const summary = details.querySelector('summary');
  summary.setAttribute('aria-expanded', 'false');
  summary.focus();
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["nlt-context-catalog"] && !Shopify.designMode) return;
  try {
    function nltContextClassifyOil(title, t) {
  const s=title.normalize('NFD').replace(/[\u0300-\u036f]/g,'').toLowerCase();
  const usage=[];
  if (/^(kit|paquete)\b/.test(s)) usage.push(t.other);
  else if (/^(aditivo|limpiador|liquido lavado)|flush|limpiador/.test(s)) usage.push(t.additives);
  else if (/anticongelante|refrigerante|coolant/.test(s)) usage.push(t.coolant);
  else if (/^filtro/.test(s)) usage.push(t.filters);
  else if (/^grasa/.test(s)) usage.push(t.grease);
  else {
    if (/transmision|transmission|\batf\b|synchromesh|powershift|supershift/.test(s)) usage.push(t.transmission);
    if (/diferencial|differencial|differential|engran|severe gear|gear lube/.test(s)) usage.push(t.differential);
    if (/aceite.*motor|motor.*aceite|\b2t\b|\b4t\b/.test(s)) usage.push(t.motor);
    if (/suspension|shock/.test(s)) usage.push(t.suspension);
  }
  if (!usage.length) usage.push(t.other);
  const lines=[[/sign[ai]ture series/,'Signature Series'],[/\boe\b/,'OE'],[/\bxl\b/,'XL'],[/dominator/,'Dominator'],[/severe gear/,'Severe Gear'],[/heavy[ -]?duty/,'Heavy-Duty'],[/premium protection/,'Premium Protection'],[/z[ -]?rod/,'Z-ROD'],[/interceptor/,'Interceptor'],[/saber/,'SABER'],[/v[ -]?twin/,'V-Twin'],[/metric motorcycle/,'Metric Motorcycle'],[/dirt bike/,'Dirt Bike'],[/atv\/utv/,'ATV/UTV'],[/synchromesh/,'Synchromesh'],[/powershift/,'Powershift'],[/super[ -]?shift/,'Super Shift'],[/grado comercial/,'Commercial Grade']];
  const line=(lines.find(([re])=>re.test(s))||[null,t.other])[1];
  const multi=[...s.matchAll(/\b(\d{1,3})\s*w\s*[-– ]?\s*(8|12|16|20|30|40|50|60|70|75|80|85|90|110|140|190|250)\b/g)].map(m=>`${Number(m[1])}W-${m[2]}`);
  const mono=s.match(/\bsae\s*(\d{2,3})\b/);
  const viscosity=multi.length?[...new Set(multi)]:[mono?`SAE ${mono[1]}`:t.unspecified];
  const measure=s.match(/\b(\d+(?:[.,]\d+)?)\s*(ml|litros?|l|kg|g)\b/);
  let size=t.unspecified;
  if (/^(kit|paquete)\b/.test(s)) size=t.kit;
  else if(measure){const raw=Number(measure[1].replace(',','.')),unit=measure[2],n=/^(l|litro|litros)$/.test(unit)&&raw===10?9.46:raw;size=/^(ml|l|litro|litros)$/.test(unit)&&[3.78,3.785].includes(n)?t.gallon:unit==='ml'&&n===946?t.quart:/^(l|litro|litros)$/.test(unit)&&n===1?t.liter:`${n} ${unit.startsWith('l')?'L':unit}`;}
  else if(/\bgal[oó]n\b/.test(s)) size=t.gallon;
  return {usage,line:[line],viscosity,size:[size]};
}
function nltContextClassify(product,t){
  const s=product.title.normalize('NFD').replace(/[\u0300-\u036f]/g,'').toLowerCase();
  const groups=[[/\b(llave|control remoto|carcasa|cascara|transponder|chip|lishi)\b/,'keys'],[/\bfiltro\b/,'filter'],[/\b(balata|freno|disco de freno|tambor de freno)\b/,'brakes'],[/\b(amortiguador|muelle|rotula|bolsa de aire|baleros?)\b/,'suspension'],[/\b(aceite|lubricante|atf|anticongelante|refrigerante|aditivo|grasa|limpiador|fluido)\b/,'fluids'],[/\b(bateria|acumulador)\b/,'battery'],[/\b(faro|foco|lampara|calavera|led)\b/,'lighting'],[/\b(alternador|marcha|sensor|relevador|bobina|bujia)\b/,'electric'],[/\b(espejo|manija|chapa|salpicadera|cofre|defensa)\b/,'body'],[/\b(cera|pulidor|polish|shampoo|sellador|microfibra)\b/,'care']];
  const isCare=/\b(adam['’]?s|koch[ -]?chemie|meguiar['’]?s|shampoo|champu|polish|polishes|graphene|grafeno|carnauba|detailing|microfibra|microfiber|ceramic coating|car wash|tire shine)\b/.test(s);
  const family=isCare?'care':(groups.find(([re])=>re.test(s))||[null,'generic'])[1];
  const result={care_type:[],care_technology:[],care_surface:[],category:[t[family]||t.generic],usage:[],line:[],viscosity:[],size:[],brand:[],make:[],model:[],year:[],frequency:[],buttons:[],chip:[],position:[],material:[],voltage:[],capacity:[]};
  if(family==='fluids'){
    const oil=nltContextClassifyOil(product.title,t);
    for(const k of ['usage','line','viscosity','size'])result[k]=oil[k].filter(v=>v&&v!==t.other&&v!==t.unspecified);
  }
  if(family==='care'){
    const name=s.replace(/\badam['’]?s\s*(?:polishes)?/g,'').trim();
    const accessory=!/cleaner|limpiador|revitalizer|detergente/.test(name)&&/\b(pad|pads|toalla|towel|microfibra|microfiber|brush|cepillo|aplicador|applicator|applcator|backing plate|pulidora|polisher|swirl killer|pistola|foam cannon|bucket|cubeta|guante|mitt)\b/.test(name);
    const rules=accessory?[[/\b(pad|pads|backing plate)\b/,'care_pads'],[/microfibra|microfiber|toalla|towel/,'care_towels'],[/brush|cepillo/,'care_brushes'],[/aplicador|applicator|applcator/,'care_applicators'],[/pulidora|polisher|swirl killer/,'care_machines']]:[
      [/shampoo|champu|car wash|mega foam|snow foam/,'care_shampoo'],
      [/compound|compuesto|scratch.*remover|swirl.*remover/,'care_compound'],
      [/\bpolish\b|pulidor|pulimento/,'care_polish'],
      [/\bwax\b|\bcera\b|carnauba/,'care_wax'],
      [/sealant|sellador/,'care_sealant'],
      [/coating|recubrimiento/,'care_coating'],
      [/detail spray|detailer|quick detail|waterless|rinseless/,'care_detailer'],
      [/tire shine|dressing|abrillantador|vrt|trim restorer|in & out/,'care_dressing'],
      [/cleaner|limpiador|degreaser|desengrasante|remover|revitalizer/,'care_cleaner'],
      [/air freshener|aromat|odor|odour/,'care_fragrance']];
    for(const [re,key]of rules)if(re.test(name))result.care_type.push(t[key]);
    if(accessory&&!result.care_type.length)result.care_type=[t.care_accessories];
    if(!accessory){
      for(const [re,key]of [[/graphene|grafeno/,'care_graphene'],[/ceramic|ceramico|sio2/,'care_ceramic'],[/carnauba/,'care_carnauba']])if(re.test(name))result.care_technology.push(t[key]);
      result.size=nltContextClassifyOil(product.title,t).size.filter(v=>v&&v!==t.unspecified);
    }
    for(const [re,key]of [[/wheel|tire|rin|rines|llanta|neumatico/,'care_wheels'],[/glass|vidrio|cristal/,'care_glass'],[/leather|cuero|piel/,'care_leather'],[/interior|carpet|tapiceria|textil/,'care_interior'],[/metal|chrome|cromo|aluminio/,'care_metal'],[/paint|pintura|car wash|shampoo|mega foam/,'care_paint']])if(re.test(name))result.care_surface.push(t[key]);
  }
  if(family==='filter'){
    for(const [re,key]of [[/aceite/,'oil_filter'],[/combustible|diesel|gasolina/,'fuel_filter'],[/aire/,'air_filter'],[/cabina|cabine|polen/,'cabin_filter'],[/hidraulico/,'hydraulic_filter'],[/transmision/,'transmission']])if(re.test(s))result.usage.push(t[key]);
    if(result.usage.includes(t.cabin_filter))result.usage=result.usage.filter(v=>v!==t.air_filter);
  }
  if(family==='keys'){
    if(/carcasa|cascara/.test(s))result.usage=[t.key_shell];
    else if(/proximidad|presencia|smart/.test(s))result.usage=[t.smart_key];
    else if(/transponder|chip/.test(s))result.usage=[t.chip];
    else if(/control/.test(s))result.usage=[t.remote];
  }
  if(product.vendor&&!/^(woocommerce|ninguno|nlt keys)$/i.test(product.vendor))result.brand=[product.vendor];
  const values=x=>(Array.isArray(x)?x:[x]).filter(v=>typeof v==='string'||typeof v==='number').map(String).filter(Boolean);
  for(const [key,source]of Object.entries({make:'marca',model:'modelo',year:'ano',frequency:'frecuencia',buttons:'botones',chip:'chip'}))result[key]=values(product.meta?.[source]);
  if(family==='keys'){
    if(!result.frequency.length){const m=s.match(/\b(\d{3}(?:[.,]\d+)?)\s*mhz\b/);if(m)result.frequency=[m[1].replace(',','.')+' MHz'];}
    if(!result.buttons.length){const m=s.match(/\b([1-9])\s*botones?\b/);if(m)result.buttons=[m[1]];}
  }
  if(['brakes','suspension','body','lighting'].includes(family)){
    for(const [re,key]of [[/\bdelanter[oa]s?\b/,'front'],[/\btraser[oa]s?\b/,'rear'],[/\bizquierd[oa]s?\b/,'left'],[/\bderech[oa]s?\b/,'right']])if(re.test(s))result.position.push(t[key]);
  }
  if(family==='brakes'){
    if(/ceramic/.test(s))result.material.push(t.ceramic);
    else if(/semi[ -]?metalic/.test(s))result.material.push(t.semi_metallic);
  }
  if(['battery','electric','lighting'].includes(family)){const m=s.match(/\b(6|12|24|48)\s*v\b/);if(m)result.voltage=[m[1]+' V'];}
  if(family==='battery'){const cca=s.match(/\b(\d{2,4})\s*cca\b/),ah=s.match(/\b(\d{1,3})\s*ah\b/);if(cca)result.capacity.push(cca[1]+' CCA');if(ah)result.capacity.push(ah[1]+' Ah');}
  return result;
}

if(!customElements.get('nlt-context-catalog')) customElements.define('nlt-context-catalog',class extends HTMLElement{
  async connectedCallback(){
    if(this.started)return;this.started=true;
    this.t={...JSON.parse(this.querySelector('[data-text]').textContent),...JSON.parse(this.querySelector('[data-context-text]').textContent)};
    this.keys=['category','care_type','care_technology','care_surface','usage','line','viscosity','size','brand','make','model','year','frequency','buttons','chip','position','material','voltage','capacity','availability'];
    this.nativeMap={availability:'filter.v.availability',brand:'filter.p.vendor',make:'filter.p.m.custom.marca',model:'filter.p.m.custom.modelo',year:'filter.p.m.custom.ano',frequency:'filter.p.m.custom.frecuencia',buttons:'filter.p.m.custom.botones',chip:'filter.p.m.custom.chip',min:'filter.v.price.gte',max:'filter.v.price.lte'};
    this.native=this.closest('.shopify-section').querySelector('.nlt-collection,.nlt-search');
    if([...new URL(location.href).searchParams.keys()].some(k=>k.startsWith('filter.')&&k!=='filter.p.product_type'&&!Object.values(this.nativeMap).includes(k))){this.hidden=true;return;}
    if(Number(this.dataset.countTotal)>(this.dataset.search==='true'?999:5000)){this.hidden=true;return;}
    this.form=this.querySelector('form');this.sort=this.querySelector('[data-sort]');this.limit=24;
    this.money=new Intl.NumberFormat(this.dataset.locale||'es-MX',{style:'currency',currency:this.dataset.currency||'MXN'});
    try{
      const fetchPage=async page=>{
        const u=new URL(location.href);for(const key of [...u.searchParams.keys()])if(key.startsWith('oil_')||(key.startsWith('filter.')&&key!=='filter.p.product_type'))u.searchParams.delete(key);u.searchParams.set('view','nlt-context-data');if(this.dataset.search==='true')u.searchParams.set('type','product');u.searchParams.set('page',page);
        const preview=new URL(location.href).searchParams.get('preview_theme_id');if(preview)u.searchParams.set('preview_theme_id',preview);
        const r=await fetch(u,{credentials:'same-origin'});if(!r.ok)throw Error('catalog');return r.json();
      };
      const first=await fetchPage(1);if(!Array.isArray(first.products))throw Error('catalog');
      if(first.total>(this.dataset.search==='true'?999:5000)){this.hidden=true;return;}
      const products=[...first.products];
      for(let page=2;page<=first.pages;page+=4){const batch=await Promise.all(Array.from({length:Math.min(4,first.pages-page+1)},(_,i)=>fetchPage(page+i)));for(const data of batch)products.push(...data.products);}
      this.products=[...new Map(products.map(p=>[p.id,p])).values()].map(p=>({...p,...nltContextClassify(p,this.t),availability:[p.available?'1':'0']}));
      for(const name of this.keys){
        const container=this.form.querySelector(`[data-options="${name}"]`);
        const values=[...new Set(this.products.flatMap(p=>p[name]||[]))].sort((a,b)=>a.localeCompare(b,'es',{numeric:true}));
        if(!values.length||(name==='category'&&values.length===1)){container.closest('details').hidden=true;continue;}
        for(const value of values){
          const label=document.createElement('label');label.className='nlt-oil-checkbox';
          const input=document.createElement('input');input.type='checkbox';input.name=name;input.value=value;
          const text=document.createElement('span');text.textContent=name==='availability'?(value==='1'?this.t.available:this.t.sold_out):value;
          label.append(input,text);container.append(label);
        }
      }
      this.readURL();
      this.form.addEventListener('submit',e=>e.preventDefault());
      this.form.addEventListener('change',()=>{this.limit=24;this.render(true).catch(()=>{});});
      this.form.addEventListener('reset',()=>setTimeout(()=>{this.sort.value='featured';this.limit=24;this.render(true).catch(()=>{});},0));
      this.sort.addEventListener('change',()=>{this.limit=24;this.render(true).catch(()=>{});});
      this.querySelector('[data-more]').addEventListener('click',()=>{this.limit+=24;this.render(false).catch(()=>{});});
      this.onPop=()=>{this.readURL();this.limit=24;this.render(false).catch(()=>{});};window.addEventListener('popstate',this.onPop);
      await this.render(false);
      if(this.dataset.search==='true'&&this.native?.querySelector('.nlt-search-heading h1'))this.querySelector('h1').textContent=this.native.querySelector('.nlt-search-heading h1').textContent;
      if(this.native)this.native.remove();
      this.hidden=false;
      this.querySelector('[data-status]').hidden=true;this.querySelector('[data-interface]').hidden=false;
    }catch(error){this.hidden=true;}
  }
  disconnectedCallback(){window.removeEventListener('popstate',this.onPop);}
  readURL(){
    const p=new URL(location.href).searchParams;
    for(const field of this.form.elements){
      if(!field.name)continue;
      if(field.type==='checkbox'){
        const values=p.getAll('oil_'+field.name).map(value=>{
          if(field.name!=='size')return value;
          if(/^3[.,]78(?:5)?\s*(?:ml|l)$/i.test(value.trim())||value==='Galón (3.785 L)')return this.t.gallon;
          if(value==='Cuarto (946 ml)')return this.t.quart;
          if(value==='Litro (1 L)')return this.t.liter;
          if(/^10\s*l$/i.test(value.trim()))return '9.46 L';
          return value;
        });
        if(!values.length&&this.nativeMap[field.name])values.push(...p.getAll(this.nativeMap[field.name]));
        field.checked=values.includes(field.value);
        if(field.checked)field.closest('details').open=true;
      }else field.value=p.get('oil_'+field.name)||(field.name==='min'?p.get('filter.v.price.gte'):field.name==='max'?p.get('filter.v.price.lte'):'')||'';
    }
    this.sort.value=p.get('oil_sort')||'featured';
  }
  async render(updateURL){
    const renderId=this.renderId=(this.renderId||0)+1;
    const data=new FormData(this.form),keys=this.keys;
    const state=Object.fromEntries(keys.map(k=>[k,data.getAll(k)]));
    state.min=data.get('min')||'';state.max=data.get('max')||'';
    for(const k of keys){this.querySelector(`[data-selection-count="${k}"]`).textContent=state[k].length?` (${state[k].length})`:'';}
    if(updateURL){
      const u=new URL(location.href);
      for(const[k,v]of Object.entries(state)){u.searchParams.delete('oil_'+k);for(const value of Array.isArray(v)?v:[v])if(value!=='')u.searchParams.append('oil_'+k,value);}
      this.sort.value==='featured'?u.searchParams.delete('oil_sort'):u.searchParams.set('oil_sort',this.sort.value);
      u.searchParams.delete('page');for(const key of [...u.searchParams.keys()])if(key.startsWith('filter.')&&key!=='filter.p.product_type')u.searchParams.delete(key);history.pushState({},'',u);
    }
    let selected=this.products.filter(p=>keys.every(k=>!state[k].length||state[k].some(v=>(p[k]||[]).includes(v)))&&(state.min===''||p.price>=Number(state.min)*100)&&(state.max===''||p.price<=Number(state.max)*100));
    if(this.sort.value==='price_up')selected.sort((a,b)=>a.price-b.price);if(this.sort.value==='price_down')selected.sort((a,b)=>b.price-a.price);if(this.sort.value==='az')selected.sort((a,b)=>a.title.localeCompare(b.title));
    this.querySelector('[data-count]').textContent=`${selected.length} ${this.t.results}`;
    const chips=this.querySelector('[data-chips]');chips.replaceChildren();
    for(const[k,values]of Object.entries(state)){
      for(const v of Array.isArray(values)?values:[values]){
        if(v==='')continue;
        const b=document.createElement('button');b.type='button';
        let label=k==='availability'?(v==='1'?this.t.available:this.t.sold_out):v;
        if(k==='min'||k==='max')label=`${k==='min'?this.t.from:this.t.to}: ${this.money.format(Number(v))}`;
        else label=`${this.t[k]}: ${label}`;
        b.textContent=label+' ×';
        b.addEventListener('click',()=>{
          for(const field of this.form.elements){if(field.name!==k)continue;if(field.type==='checkbox'){if(field.value===v)field.checked=false;}else field.value='';}
          this.limit=24;this.render(true).catch(()=>{});
        });chips.append(b);
      }
    }
    const grid=this.querySelector('[data-products]');grid.setAttribute('aria-busy','true');
    const visible=selected.slice(0,this.limit);
    try{
      for(let start=0;start<visible.length;start+=6){
        await Promise.all(visible.slice(start,start+6).map(async product=>{
          if(product.card)return;
          const url=new URL(product.url,location.origin);url.searchParams.set('view','nlt-context-card');
          const preview=new URL(location.href).searchParams.get('preview_theme_id');if(preview)url.searchParams.set('preview_theme_id',preview);
          const response=await fetch(url,{credentials:'same-origin'});if(!response.ok)throw Error('card');
          const data=await response.json();if(!data.card)throw Error('card');product.card=data.card;
        }));
        if(renderId!==this.renderId)return;
      }
      grid.replaceChildren();
      for(const p of visible){
        const card=document.createElement('div');card.className='nlt-oil-native-card';
        card.innerHTML=p.card.replaceAll('<quick-add-bulk','<nlt-context-quick-add-bulk').replaceAll('</quick-add-bulk>','</nlt-context-quick-add-bulk>');
        for(const control of card.querySelectorAll('nlt-context-quick-add-bulk'))control.id=`nlt-context-quantity-${p.id}`;
        grid.append(card);
      }
      grid.removeAttribute('aria-busy');
    }catch(error){
      if(renderId!==this.renderId)return;
      this.hidden=true;
      this.querySelector('[data-interface]').hidden=true;if(this.native&&!this.native.isConnected){this.native=this.native.cloneNode(true);this.after(this.native);}throw error;
    }
    this.querySelector('[data-empty]').hidden=selected.length>0;this.querySelector('[data-more]').hidden=selected.length<=this.limit;
  }
});

customElements.whenDefined('quick-add-bulk').then(()=>{
  if(customElements.get('nlt-context-quick-add-bulk'))return;
  customElements.define('nlt-context-quick-add-bulk',class extends customElements.get('quick-add-bulk'){
    sendRequest(queue,element){this.requestStarted=true;const items={};for(const item of queue)items[item.id]=item.quantity;this.queue=this.queue.filter(item=>!queue.includes(item));this.updateMultipleQty(items,element);}
    getSectionsToRender(){return [{id:'cart-icon-bubble',section:'cart-icon-bubble',selector:'.shopify-section'},{id:'CartDrawer',section:'cart-drawer',selector:'#CartDrawer'}];}
    syncOilQuantity(cart){
      const input=this.querySelector('quantity-input input');if(!input)return;
      const quantity=cart.items.filter(item=>String(item.variant_id)===String(this.dataset.index)).reduce((sum,item)=>sum+item.quantity,0);
      input.value=quantity;input.setAttribute('value',quantity);input.dataset.cartQuantity=quantity;
      this.querySelector('quantity-input')?.validateQtyRules?.();
    }
    async onCartUpdate(){const response=await fetch(`${routes.cart_url}.js`,{credentials:'same-origin'});if(!response.ok)return;this.syncOilQuantity(await response.json());}
    renderSections(state,ids){super.renderSections(state,ids);if(Array.isArray(state.items))document.querySelectorAll('nlt-context-quick-add-bulk').forEach(control=>control.syncOilQuantity(state));}
    init(){super.init();this.onCartUpdate().catch(()=>{});}
  });
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["nlt-key-home"] && !Shopify.designMode) return;
  try {
    if(!customElements.get('nlt-key-home')){
customElements.define('nlt-key-home',class extends HTMLElement{
connectedCallback(){
const init=()=>{
if(this.dataset.ready)return;
const form=this.querySelector('form');
if(!form)return;
this.dataset.ready='true';
form.addEventListener('formdata',event=>{
const query=form.querySelector('[name=q]').value.trim();
const brand=form.querySelector('[data-brand]').value;
const category=form.querySelector('[data-category]').value;
const exact=value=>(value.match(/"[^"]+"|\S+/g)||[]).map(term=>'"'+term.replaceAll('"','')+'"').join(' ');
const parts=[exact(query),brand?exact(brand):'',category].filter(Boolean);
if(!query&&!category)parts.unshift(this.dataset.baseQuery);
event.formData.set('q',parts.join(' '));
});
};
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init,{once:true});else init();
}
});
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["nlt-key-quote"] && !Shopify.designMode) return;
  try {
    if(!customElements.get('nlt-key-quote')){
customElements.define('nlt-key-quote',class extends HTMLElement{
connectedCallback(){
const initialize=()=>{
if(this.dataset.ready)return;
const form=this.querySelector('form'),button=this.querySelector('[data-quote-send]'),message=this.querySelector('[data-quote-message]');
if(!form||!button||!message)return;
this.dataset.ready='true';
const visit=form.querySelector('[data-field="visit"]'),location=form.querySelector('[data-field="location"]'),locationGroup=form.querySelector('[data-location-group]');
const update=()=>{
const home=!!visit.selectedOptions[0]?.hasAttribute('data-home-visit');
locationGroup.hidden=!home;
location.disabled=!home;
const fields=[...form.querySelectorAll('[data-label]')];
message.value=[this.dataset.message,...fields.filter(field=>!field.disabled && field.value.trim()).map(field=>field.dataset.label+': '+field.value.trim())].join('\n');
};
form.addEventListener('input',update);
form.addEventListener('change',update);
form.addEventListener('submit',()=>{update();});
button.addEventListener('click',update);
update();
button.disabled=false;
};
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',initialize,{once:true});
else initialize();
}
});
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["nlt-locksmith-panel"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('nlt-locksmith-menu')) {
    customElements.define('nlt-locksmith-menu', class extends HTMLElement {
      connectedCallback() {
        const categories = [...this.querySelectorAll('.nlt-locksmith__category')];
        const activate = current => categories.forEach(item => { if (item !== current) item.open = false; });
        categories.forEach(item => {
          item.addEventListener('toggle', () => { if (item.open) activate(item); });
          item.querySelector('summary').addEventListener('pointerenter', () => {
            if (!this.classList.contains('nlt-locksmith--drawer') && matchMedia('(min-width:990px) and (hover:hover)').matches) {
              activate(item);
              item.open = true;
            }
          });
        });
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["nlt-oil-catalog"] && !Shopify.designMode) return;
  try {
    function nltClassifyOil(title, t) {
  const s=title.normalize('NFD').replace(/[\u0300-\u036f]/g,'').toLowerCase();
  const usage=[];
  if (/^(kit|paquete)\b/.test(s)) usage.push(t.other);
  else if (/^(aditivo|limpiador|liquido lavado)|flush|limpiador/.test(s)) usage.push(t.additives);
  else if (/anticongelante|refrigerante|coolant/.test(s)) usage.push(t.coolant);
  else if (/^filtro/.test(s)) usage.push(t.filters);
  else if (/^grasa/.test(s)) usage.push(t.grease);
  else {
    if (/transmision|transmission|\batf\b|synchromesh|powershift|supershift/.test(s)) usage.push(t.transmission);
    if (/diferencial|differencial|differential|engran|severe gear|gear lube/.test(s)) usage.push(t.differential);
    if (/aceite.*motor|motor.*aceite|\b2t\b|\b4t\b/.test(s)) usage.push(t.motor);
    if (/suspension|shock/.test(s)) usage.push(t.suspension);
  }
  if (!usage.length) usage.push(t.other);
  const lines=[[/sign[ai]ture series/,'Signature Series'],[/\boe\b/,'OE'],[/\bxl\b/,'XL'],[/dominator/,'Dominator'],[/severe gear/,'Severe Gear'],[/heavy[ -]?duty/,'Heavy-Duty'],[/premium protection/,'Premium Protection'],[/z[ -]?rod/,'Z-ROD'],[/interceptor/,'Interceptor'],[/saber/,'SABER'],[/v[ -]?twin/,'V-Twin'],[/metric motorcycle/,'Metric Motorcycle'],[/dirt bike/,'Dirt Bike'],[/atv\/utv/,'ATV/UTV'],[/synchromesh/,'Synchromesh'],[/powershift/,'Powershift'],[/super[ -]?shift/,'Super Shift'],[/grado comercial/,'Commercial Grade']];
  const line=(lines.find(([re])=>re.test(s))||[null,t.other])[1];
  const multi=[...s.matchAll(/\b(\d{1,3})\s*w\s*[-– ]?\s*(8|12|16|20|30|40|50|60|70|75|80|85|90|110|140|190|250)\b/g)].map(m=>`${Number(m[1])}W-${m[2]}`);
  const mono=s.match(/\bsae\s*(\d{2,3})\b/);
  const viscosity=multi.length?[...new Set(multi)]:[mono?`SAE ${mono[1]}`:t.unspecified];
  const measure=s.match(/\b(\d+(?:[.,]\d+)?)\s*(ml|litros?|l|kg|g)\b/);
  let size=t.unspecified;
  if (/^(kit|paquete)\b/.test(s)) size=t.kit;
  else if(measure){const raw=Number(measure[1].replace(',','.')),unit=measure[2],n=/^(l|litro|litros)$/.test(unit)&&raw===10?9.46:raw;size=/^(ml|l|litro|litros)$/.test(unit)&&[3.78,3.785].includes(n)?t.gallon:unit==='ml'&&n===946?t.quart:/^(l|litro|litros)$/.test(unit)&&n===1?t.liter:`${n} ${unit.startsWith('l')?'L':unit}`;}
  else if(/\bgal[oó]n\b/.test(s)) size=t.gallon;
  return {usage,line:[line],viscosity,size:[size]};
}
if(!customElements.get('nlt-oil-catalog')) customElements.define('nlt-oil-catalog',class extends HTMLElement{
  async connectedCallback(){
    if(this.started)return;this.started=true;
    this.t=JSON.parse(this.querySelector('[data-text]').textContent);
    this.form=this.querySelector('form');this.sort=this.querySelector('[data-sort]');this.limit=24;
    this.money=new Intl.NumberFormat(this.dataset.locale||'es-MX',{style:'currency',currency:this.dataset.currency||'MXN'});
    try{
      const fetchPage=async page=>{
        const u=new URL(this.dataset.url,location.origin);u.searchParams.set('view','nlt-oil-data');u.searchParams.set('page',page);
        const preview=new URL(location.href).searchParams.get('preview_theme_id');if(preview)u.searchParams.set('preview_theme_id',preview);
        const r=await fetch(u,{credentials:'same-origin'});if(!r.ok)throw Error('catalog');return r.json();
      };
      const first=await fetchPage(1);if(!Array.isArray(first.products))throw Error('catalog');
      const products=[...first.products];
      for(let page=2;page<=first.pages;page++){const data=await fetchPage(page);products.push(...data.products);}
      this.products=[...new Map(products.map(p=>[p.id,p])).values()].map(p=>({...p,...nltClassifyOil(p.title,this.t),availability:[p.available?'1':'0']}));
      for(const name of ['usage','line','viscosity','size','availability']){
        const container=this.form.querySelector(`[data-options="${name}"]`);
        const values=[...new Set(this.products.flatMap(p=>p[name]))].sort((a,b)=>a.localeCompare(b,'es',{numeric:true}));
        for(const value of values){
          const label=document.createElement('label');label.className='nlt-oil-checkbox';
          const input=document.createElement('input');input.type='checkbox';input.name=name;input.value=value;
          const text=document.createElement('span');text.textContent=name==='availability'?(value==='1'?this.t.available:this.t.sold_out):value;
          label.append(input,text);container.append(label);
        }
      }
      this.readURL();
      this.form.addEventListener('submit',e=>e.preventDefault());
      this.form.addEventListener('change',()=>{this.limit=24;this.render(true);});
      this.form.addEventListener('reset',()=>setTimeout(()=>{this.sort.value='featured';this.limit=24;this.render(true);},0));
      this.sort.addEventListener('change',()=>{this.limit=24;this.render(true);});
      this.querySelector('[data-more]').addEventListener('click',()=>{this.limit+=24;this.render(false);});
      this.onPop=()=>{this.readURL();this.limit=24;this.render(false);};window.addEventListener('popstate',this.onPop);
      this.render(false);
      const native=this.closest('.shopify-section').querySelector('.nlt-collection');if(native)native.remove();
      this.querySelector('[data-status]').hidden=true;this.querySelector('[data-interface]').hidden=false;
    }catch(error){this.querySelector('[data-status]').textContent=this.t.error;}
  }
  disconnectedCallback(){window.removeEventListener('popstate',this.onPop);}
  readURL(){
    const p=new URL(location.href).searchParams;
    for(const field of this.form.elements){
      if(!field.name)continue;
      if(field.type==='checkbox'){
        const values=p.getAll('oil_'+field.name).map(value=>{
          if(field.name!=='size')return value;
          if(/^3[.,]78(?:5)?\s*(?:ml|l)$/i.test(value.trim())||value==='Galón (3.785 L)')return this.t.gallon;
          if(value==='Cuarto (946 ml)')return this.t.quart;
          if(value==='Litro (1 L)')return this.t.liter;
          if(/^10\s*l$/i.test(value.trim()))return '9.46 L';
          return value;
        });
        if(!values.length&&field.name==='availability')values.push(...p.getAll('filter.v.availability'));
        field.checked=values.includes(field.value);
        if(field.checked)field.closest('details').open=true;
      }else field.value=p.get('oil_'+field.name)||(field.name==='min'?p.get('filter.v.price.gte'):field.name==='max'?p.get('filter.v.price.lte'):'')||'';
    }
    this.sort.value=p.get('oil_sort')||'featured';
  }
  render(updateURL){
    const data=new FormData(this.form),keys=['usage','line','viscosity','size','availability'];
    const state=Object.fromEntries(keys.map(k=>[k,data.getAll(k)]));
    state.min=data.get('min')||'';state.max=data.get('max')||'';
    for(const k of keys){this.querySelector(`[data-selection-count="${k}"]`).textContent=state[k].length?` (${state[k].length})`:'';}
    if(updateURL){
      const u=new URL(location.href);
      for(const[k,v]of Object.entries(state)){u.searchParams.delete('oil_'+k);for(const value of Array.isArray(v)?v:[v])if(value!=='')u.searchParams.append('oil_'+k,value);}
      this.sort.value==='featured'?u.searchParams.delete('oil_sort'):u.searchParams.set('oil_sort',this.sort.value);
      u.searchParams.delete('page');for(const key of ['filter.v.price.gte','filter.v.price.lte','filter.v.availability'])u.searchParams.delete(key);history.pushState({},'',u);
    }
    let selected=this.products.filter(p=>keys.every(k=>!state[k].length||state[k].some(v=>p[k].includes(v)))&&(state.min===''||p.price>=Number(state.min)*100)&&(state.max===''||p.price<=Number(state.max)*100));
    if(this.sort.value==='price_up')selected.sort((a,b)=>a.price-b.price);if(this.sort.value==='price_down')selected.sort((a,b)=>b.price-a.price);if(this.sort.value==='az')selected.sort((a,b)=>a.title.localeCompare(b.title));
    this.querySelector('[data-count]').textContent=`${selected.length} ${this.t.results}`;
    const chips=this.querySelector('[data-chips]');chips.replaceChildren();
    for(const[k,values]of Object.entries(state)){
      for(const v of Array.isArray(values)?values:[values]){
        if(v==='')continue;
        const b=document.createElement('button');b.type='button';
        let label=k==='availability'?(v==='1'?this.t.available:this.t.sold_out):v;
        if(k==='min'||k==='max')label=`${k==='min'?this.t.from:this.t.to}: ${this.money.format(Number(v))}`;
        else label=`${this.t[k]}: ${label}`;
        b.textContent=label+' ×';
        b.addEventListener('click',()=>{
          for(const field of this.form.elements){if(field.name!==k)continue;if(field.type==='checkbox'){if(field.value===v)field.checked=false;}else field.value='';}
          this.limit=24;this.render(true);
        });chips.append(b);
      }
    }
    const grid=this.querySelector('[data-products]');grid.replaceChildren();
    for(const p of selected.slice(0,this.limit)){
      const card=document.createElement('div');card.className='nlt-oil-native-card';
      card.innerHTML=p.card.replaceAll('<quick-add-bulk','<nlt-oil-quick-add-bulk').replaceAll('</quick-add-bulk>','</nlt-oil-quick-add-bulk>');
      for(const control of card.querySelectorAll('nlt-oil-quick-add-bulk'))control.id=`nlt-oil-quantity-${p.id}`;
      grid.append(card);
    }
    this.querySelector('[data-empty]').hidden=selected.length>0;this.querySelector('[data-more]').hidden=selected.length<=this.limit;
  }
});

customElements.whenDefined('quick-add-bulk').then(()=>{
  if(customElements.get('nlt-oil-quick-add-bulk'))return;
  customElements.define('nlt-oil-quick-add-bulk',class extends customElements.get('quick-add-bulk'){
    sendRequest(queue,element){this.requestStarted=true;const items={};for(const item of queue)items[item.id]=item.quantity;this.queue=this.queue.filter(item=>!queue.includes(item));this.updateMultipleQty(items,element);}
    getSectionsToRender(){return [{id:'cart-icon-bubble',section:'cart-icon-bubble',selector:'.shopify-section'},{id:'CartDrawer',section:'cart-drawer',selector:'#CartDrawer'}];}
    syncOilQuantity(cart){
      const input=this.querySelector('quantity-input input');if(!input)return;
      const quantity=cart.items.filter(item=>String(item.variant_id)===String(this.dataset.index)).reduce((sum,item)=>sum+item.quantity,0);
      input.value=quantity;input.setAttribute('value',quantity);input.dataset.cartQuantity=quantity;
      this.querySelector('quantity-input')?.validateQtyRules?.();
    }
    async onCartUpdate(){const response=await fetch(`${routes.cart_url}.js`,{credentials:'same-origin'});if(!response.ok)return;this.syncOilQuantity(await response.json());}
    renderSections(state,ids){super.renderSections(state,ids);if(Array.isArray(state.items))document.querySelectorAll('nlt-oil-quick-add-bulk').forEach(control=>control.syncOilQuantity(state));}
    init(){super.init();this.onCartUpdate().catch(()=>{});}
  });
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["nlt-search-categories"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click',function(event){
 const link=event.target.closest('a[data-nlt-category-target]');
 if(!link)return;
 const url=new URL(window.location.href);
 url.searchParams.set('q',link.dataset.nltCategoryTarget);
 url.searchParams.set('type','product');
 url.searchParams.delete('page');
 link.href=url.toString();
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["nlt-truck-offer"] && !Shopify.designMode) return;
  try {
    if(!customElements.get('nlt-truck-offer')){
customElements.define('nlt-truck-offer',class extends HTMLElement{
connectedCallback(){
const initialize=()=>{
if(this.dataset.ready)return;
const form=this.querySelector('form');
if(!form)return;
this.dataset.ready='true';
const name=form.querySelector('[data-offer-name]'),amount=form.querySelector('[data-offer-amount]'),message=form.querySelector('[data-offer-message]'),button=form.querySelector('button');
const update=()=>{
const value=Number(amount.value);
const money=Number.isFinite(value)&&value>0?new Intl.NumberFormat('es-MX',{style:'currency',currency:'MXN'}).format(value)+' MXN':amount.value;
message.value=[this.dataset.intro,'Stock: '+this.dataset.stock,name.dataset.label+': '+name.value.trim(),amount.dataset.label+': '+money,this.dataset.details||this.dataset.url].join('\n');
};
form.addEventListener('input',update);
form.addEventListener('change',update);
form.addEventListener('submit',update);
button.addEventListener('click',update);
update();button.disabled=false;
};
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',initialize,{once:true});else initialize();
}
});
}
  } catch(e) { console.error(e); }
})();

})();
